import { render } from "./dispatch-supply.vue?vue&type=template&id=64b8195f&scoped=true"
import script from "./dispatch-supply.vue?vue&type=script&lang=js"
export * from "./dispatch-supply.vue?vue&type=script&lang=js"

import "./dispatch-supply.vue?vue&type=style&index=0&id=64b8195f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b8195f"]])

export default __exports__